import React from 'react'

type Props = { title: string, icon: React.ReactNode, children: React.ReactNode }
const IconTitleSection: React.FC<Props> = ({ title, icon, children }) => {
  return (
    <div className='sm:flex gap-x-4'>
      <div className='flex sm:block items-center gap-x-4'>
        <div className='w-8 sm:w-12'>
          {icon}
        </div>
        <h5 className='sm:hidden'>{title}</h5>
      </div>
      <div className='flex-1'>
        <h5 className='hidden sm:block mb-2'>{title}</h5>
        {children}
      </div>
    </div>
  )
}

export default IconTitleSection
